import { useRef } from "react"

import { PropTypes } from "@l2r-front/l2r-proptypes"
import { useApplicationContext } from "@l2r-front/l2r-utils"

import { ThresholdBottomSheet } from "../../components/ThresholdBottomSheet"

import * as Styled from "./BottomSheetMobileLayout.styled"

export function BottomSheetMobileLayout(props) {

    const {
        mapProps,
        MapComponent,
        MapRouter,
        BottomSheetRouter,
    } = props

    const [state, dispatch] = useApplicationContext()
    const { currentBottomSheetHeight } = state
    const { setCurrentBottomSheetHeight } = dispatch

    const containerRef = useRef(null)

    return (
        <Styled.Container ref={containerRef}>
            <MapComponent mapProps={{ ...mapProps }} translateTopAnchor>
                <MapRouter />
            </MapComponent>
            <ThresholdBottomSheet container={() => containerRef.current} height={currentBottomSheetHeight} setHeight={setCurrentBottomSheetHeight}>
                <BottomSheetRouter />
            </ThresholdBottomSheet>
        </Styled.Container>
    )
}

BottomSheetMobileLayout.propTypes = {
    mapProps: PropTypes.mapType,
    BottomSheetRouter: PropTypes.func.isRequired,
    MapComponent: PropTypes.func.isRequired,
    MapRouter: PropTypes.func.isRequired,
}